import { Editor } from '@tinymce/tinymce-react';
import { EventHandler } from '@tinymce/tinymce-react/lib/cjs/main/ts/Events';
import React, { useEffect, useRef, useState } from 'react';
import { TinyMceMediaSelector } from './tinyMceMediaSelector';

export function TinyMce(params: {
    tagName?: string;
    textareaName?: string;
    value?: any;
    disabled?: boolean;
    onChange?: EventHandler<any>;
}) {
    const [isOpen, setIsOpen] = useState(false);
    const editorRef = useRef<any>(null);

    function handleImageSelect(imageSrc: string | ArrayBuffer | null, width?: string, height?: string) {
        if (imageSrc && editorRef.current) {
            const imgTag = `<img src="${imageSrc}" alt="Selected Image" width="${width}" height="${height}" />`;
            editorRef.current.insertContent(imgTag);
        }
    };

    return (
        <>
            <Editor
                apiKey="rwq3acpj3jfdi6na6gjwjq1ebkyrnvrjfi21xcrlt9li6dss"
                onInit={(evt, editor) => (editorRef.current = editor)}
                init={{
                    height: 500,
                    menubar: false,
                    plugins: [
                        'advlist autolink lists link image charmap print preview anchor',
                        'searchreplace visualblocks code fullscreen',
                        'insertdatetime media table paste code help wordcount'
                    ],
                    toolbar: 'undo redo | formatselect | ' +
                        'bold italic backcolor | alignleft aligncenter ' +
                        'alignright alignjustify | bullist numlist outdent indent | ' +
                        'removeformat link image table media | mediaGallery',
                    setup: function (editor) {
                        editor.ui.registry.addButton('mediaGallery', {
                            text: 'Media Gallery',
                            icon: 'gallery',
                            tooltip: 'Open Media Gallery',
                            onAction: function () {
                                setIsOpen(true);
                            },
                        });
                    },
                }}
                tagName={params.tagName}
                textareaName={params.textareaName}
                value={params.value}
                onEditorChange={params.onChange}
            />

            <TinyMceMediaSelector
                open={isOpen}
                onClose={() => setIsOpen(false)}
                onImageSelect={handleImageSelect}
            />
        </>
    );
};

